import React, {useEffect, useState} from 'react';
import userService from "../../../../../common/apis/user/UserApiClient";
import Dialog from '../../../../../components/dialogs/Dialog';
import DialogTitle from '../../../../../components/dialogs/DialogTitle';
import DialogContent from '../../../../../components/dialogs/DialogContent';
import DialogActions from '../../../../../components/dialogs/DialogActions';
import SingleSelectField from "../../../../../components/fields/select/SingleSelectField";
import Grid from '../../../../../components/dialogs/Grid';
import {ButtonLayout, NegativeButtons, PositiveButtons} from "../../../../../components/button/ButtonLayout";
import {SaveButton} from "../../../../../components/button/SaveButton";
import {CancelButton} from "../../../../../components/button/CancelButton";
import {_transl} from '../../../../../store/localization/TranslMessasge';
import {UserDto} from "../../../../../common/apis/user/UserDto";
import {UserRoleType} from "../../../../../common/access/UserRoleType";
import {UserRoleTranslator} from "./UserRoleTranslator";
import {UsersTranslationKey} from "../UsersTranslationKey";
import {CommonTranslationKey} from "../../CommonTranslationKey";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";
import Snackbar from "../../snackbar/Snackbar";

interface UserRoleUpdateDialogProps {
    open: boolean;
    user: UserDto;
    availableRoles: UserRoleType[];
    onClose: () => void;
    onUpdated: () => void;
}

export default function UserRoleUpdateDialog({open, user, availableRoles, onClose, onUpdated}: UserRoleUpdateDialogProps) {
    const [selectedRole, setSelectedRole] = useState<UserRoleType>(user.role);
    const [inProgress, setInProgress] = useState(false);

    useEffect(() => {
        if (open) {
            setSelectedRole(user.role);
        }
    }, [open, user]);

    function save() {
        if (selectedRole === user.role) {
            onClose();
            return;
        }

        setInProgress(true);
        userService.updateRoleByLogin(user.login, selectedRole)
                .then(() => {
                    onUpdated();
                    onClose();
                    Snackbar.success(_transl(CommonTranslationKey.DATA_SAVED_SUCCESSFULLY));
                })
                .catch((error) => Snackbar.error(_transl(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error))
                .finally(() => setInProgress(false));
    }

    function formatRole(role: UserRoleType): string {
        return UserRoleTranslator.get().translateUserRole(role) ?? "";
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm">
            <DialogTitle title={_transl(UsersTranslationKey.USER_ROLE)}
                         onDialogClosed={onClose}/>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <SingleSelectField
                                label={_transl(UsersTranslationKey.USER_ROLE)}
                                value={selectedRole}
                                onChange={(value) => setSelectedRole(value as UserRoleType)}
                                options={availableRoles}
                                required={true}
                                getOptionLabel={(role) => formatRole(role)} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonLayout>
                    <PositiveButtons>
                        <SaveButton onClick={save} disabled={inProgress}/>
                    </PositiveButtons>
                    <NegativeButtons>
                        <CancelButton onClick={onClose} disabled={inProgress}/>
                    </NegativeButtons>
                </ButtonLayout>
            </DialogActions>
        </Dialog>
    );
}
